import { trackEvent } from '@fs/zion-analytics'

// Event names must match FamilyConnect iOS's `Analytic.CenterSessionPresentation` strings exactly.

export const trackDiscoveryCodeHomeCardImpression = () =>
  trackEvent({ event_name: 'discovery: center session home card impression' })

export const trackDiscoveryCodeHideConfirmed = () =>
  trackEvent({ event_name: 'discovery: center session hide confirmed' })

export const trackDiscoveryCodeNaturalExpiry = () =>
  trackEvent({ event_name: 'discovery: center session natural expiry' })

export const trackDiscoveryCodeSessionReplaced = () => trackEvent({ event_name: 'discovery: center session replaced' })

export const trackDiscoveryCodeRescanRestored = () =>
  trackEvent({ event_name: 'discovery: center session rescan restored' })

export const trackDiscoveryCodeLiveActivityTapped = () =>
  trackEvent({ event_name: 'discovery: center session live activity tapped' })

export const trackDiscoveryCodeLiveActivityUnavailable = (reason) =>
  trackEvent({ event_name: 'discovery: center session live activity unavailable', reason })
